import { getAccess, getAccessProjectsData, extractProfileData } from "@/utils/helpers";
import { keyCloakLogin } from "@/utils/apiFunction";
import config from "@/utils/config";

export default {
  methods: {
    goToDashboard() {
      this.userDropdownOpen = false;
      const loginType = this.$store.state.userVUEX.loginType;
      if (loginType === "candidate") {
        window.open(config.candidateBase + "/homepage?from=candidate", "_self");
      } else if (loginType === "admin") {
        const lastAdminProject = localStorage.getItem("lastAdminProject") || "admin";
        this.$store.dispatch('userVUEX/goToPage', {
          project: lastAdminProject,
          details: getAccessProjectsData(),
          loggedIn: true
        });
      } else {
        // Fallback
        if (getAccess("candidate")) {
          window.open(config.candidateBase + "/homepage?from=candidate", "_self");
        } else {
          const lastAdminProject = localStorage.getItem("lastAdminProject") || "admin";
          this.$store.dispatch('userVUEX/goToPage', {
            project: lastAdminProject,
            details: getAccessProjectsData(),
            loggedIn: true
          });
        }
      }
    },
    async fetchAndUpdateUserProfile() {
      if (!this.isLoggedIn) return;
      const token = getAccess("accessToken");
      if (!token) return;

      try {
        const response = await keyCloakLogin(token);
        if (response && response.data && response.data.details) {
          let userDataToStore = { ...response.data };
          const loginType = this.$store.state.userVUEX.loginType || (getAccess("candidate") ? "candidate" : "admin");
          const { image, username } = extractProfileData(response.data.details, loginType);
          
          userDataToStore.image = image;
          userDataToStore.username = username;
          this.$store.commit("userVUEX/setProfileData", userDataToStore);
        }
      } catch (error) {
        console.error("Failed to fetch user profile", error);
      }
    }
  }
};
